module.exports = __webpack_public_path__ + "static/media/Vegan_Model_Front_9b8f2702-9d16-46dc-a933-5d5246361e9e.9ac6d890.png";